import { Injectable } from '@angular/core';
import { Qualifier } from 'src/app/types/qualifier';
import { CastingLinkValue } from 'src/app/components/att-casting-view/formats/casting-link/casting-link.component';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

@Injectable({
	providedIn: 'root'
})
export class LinkQualifierService implements Qualifier {
	static supportedStats = ['first', 'last'];
	static FromString(value: string, linkInfo: CastingLinkValue): string {
		let retValue = value;
		if (linkInfo.base !== '') {
			if (value.indexOf(linkInfo.base) === 0) {
				retValue = value.substring(linkInfo.base.length);
			}
		}
		return retValue;
	}
	static ToString(value: string, linkInfo: CastingLinkValue): string {
		let retValue = '';
		if (linkInfo.base !== '') {
			if (value.indexOf(linkInfo.base) === -1) {
				retValue += linkInfo.base;
			}
		}
		retValue += value;
		return retValue;
	}

	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return LinkQualifierService.ToHyperLink(attribute, castingMode, val);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if([undefined,null].indexOf(val) > -1) {
			return '';
		}
		return val;
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		
		const casting: CastingValue = attribute.casting[castingMode];
		return LinkQualifierService.FromString(value, casting.link);
	}
	public static ToHyperLink(attribute, castingMode: CastingMode, val: any) {

		if (val.indexOf('http') === -1) {
			return val;
		}
		if (!!attribute.casting) {
			if (!!attribute.casting[castingMode]) {
				if (!!attribute.casting[castingMode].link) {
					const casting: CastingValue = attribute.casting[castingMode];
					const linkInfo: CastingLinkValue = casting.link;
					const label = linkInfo.label;
					switch (linkInfo.display) {
						case 'label':
							return '<a href="' + val + '" target="_blank">' + label + '</a>';
						case 'url':
							return '<a href="' + val + '" target="_blank">' + val + '</a>';
						case 'both':
							return '<a href="' + val + '" target="_blank">' + label + ' (' + val + ')' + '</a>';
					}
				}
			}
		}
		return this.ToUnCastLink(val);

	}
	public static ToUnCastLink(val: any) {
		return '<a href="' + val + '" target="_blank">click to view</a>';
	}
	static SupportsStat(statName: string) {
		return LinkQualifierService.supportedStats.indexOf[statName];
	}
	constructor() { }
}
